import { detect } from 'detect-browser';

const browser = detect();

/**
 * choose parameters here:
 * https://github.com/DamonOehlman/detect-browser/blob/master/src/index.ts
 */

// Browsers
const isIE = browser && browser.name === 'ie';
const isFirefox = browser && browser.name === 'firefox';
const isSafariIOS = browser && browser.name === 'ios';
const isSafari = browser && browser.name === 'safari';

// OSs
const isIOS = browser && browser.os === 'iOS';
const isAndroid = browser && browser.os === 'Android OS';

export default {
  isAndroid,
  isFirefox,
  isSafariIOS,
  isSafari,
  isIOS,
  isIE
};
